var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screening-progress-insights-tab"},[_c('screening-progress-card',{attrs:{"review":_vm.review,"current-researcher":_vm.currentResearcher}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }